// // Import the functions you need from the SDKs you need

import {
  FB_DB_URL,
  FCM_API_KEY,
  FCM_APP_ID,
  FCM_AUTH_DOMAIN,
  FCM_MEASUREMENT_ID,
  FCM_MESSAGING_SENDER_ID,
  FCM_PROJECT_ID,
  FCM_STORAGE_BUCKET,
  FCM_VAPID_KEY,
} from './constant';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getDatabase } from 'firebase/database';
import { getMessaging, getToken } from 'firebase/messaging';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: FCM_API_KEY,
  authDomain: FCM_AUTH_DOMAIN,
  databaseURL: FB_DB_URL,
  projectId: FCM_PROJECT_ID,
  storageBucket: FCM_STORAGE_BUCKET,
  messagingSenderId: FCM_MESSAGING_SENDER_ID,
  appId: FCM_APP_ID,
  measurementId: FCM_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const messaging = getMessaging(app);
export const database = getDatabase(app);
export default app;

export async function requestPermission() {
  //requesting permission using Notification API
  const permission = await Notification.requestPermission();
  console.log({ permission });
  console.log({ FCM_VAPID_KEY });
  if (permission === 'granted') {
    const token = await getToken(messaging, {
      vapidKey:
        'BFYHUY_QZxL_AIpCDW1do3lQgkRj6-IVsYBHR3tHLvNWX4wKZtppPet8XNUYuWXI6784dmWwhH5zobQBMxmZ55U',
    });

    //We can send token to server
    console.log('Token generated : ', token);
  } else if (permission === 'denied') {
    //notifications are blocked
    alert('You denied for the notification');
  }
}
